"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fetcher = _interopRequireDefault(require("./useSearchNew/fetcher"));
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataFetchReducer = function dataFetchReducer(state, action) {
  switch (action.type) {
    case "FETCH_INIT":
      return _objectSpread(_objectSpread({}, state), {}, {
        data: [],
        isLoading: true
      });
    case "FETCH_SUCCESS":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: action.payload
      });
    case "FETCH_FAILURE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: []
      });
    default:
      throw new Error();
  }
};
var useQuickSearch = function useQuickSearch(language) {
  var _useState = (0, _react.useState)(null),
    phrase = _useState[0],
    setPhrase = _useState[1];
  var _useReducer = (0, _react.useReducer)(dataFetchReducer, {
      isLoading: false,
      isError: false,
      data: []
    }),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  (0, _react.useEffect)(function () {
    var didCancel = false;
    if (!phrase) return;
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: "FETCH_INIT"
                });
                _context.prev = 1;
                _context.next = 4;
                return (0, _fetcher["default"])({
                  phrase: phrase,
                  language: language,
                  isQuickSearch: true
                });
              case 4:
                result = _context.sent;
                if (!didCancel) {
                  dispatch({
                    type: "FETCH_SUCCESS",
                    payload: result
                  });
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                if (!didCancel) {
                  dispatch({
                    type: "FETCH_FAILURE"
                  });
                }
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchData();
    return function () {
      didCancel = true;
    };
  }, [phrase]);
  return {
    state: state,
    setPhrase: setPhrase,
    phrase: phrase
  };
};
var _default = useQuickSearch;
exports["default"] = _default;